import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import DashboardApi from "../../api/DashboardApi";
import axios from "axios";

const savedUser = localStorage.getItem("user");

const agentInfo = localStorage.getItem("agent-Info");
const identificationToken = process.env.REACT_APP_IDENTIFICATION_TOKEN_CHECK;
const prodApiUrl = "https://applicationbackend.jalikoi.rw/api/v2";
// const apiUrl = "http://applicationbackendstaging.jalikoi.rw/api/v1";
const apiUrl = "https://applicationbackend.jalikoi.rw/api/v1";

const carleasingApiUrl = "https://applicationbackend.jalikoi.rw/api/v2";

export const fetchAsyncLoggedinUser = createAsyncThunk(
  "untapped/user-accounts",
  async ({ user_info }) => {
    const response = await DashboardApi.get(`/accounts/edit/`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${JSON.parse(savedUser.access)}`,
      },
    });

    return response.data;
  },
);

// moto leasing
export const fetchAsyncMotoleasing = createAsyncThunk(
  "applicatants/motoleasing",
  async () => {
    const response = await axios.get(`${apiUrl}/motoleasing`);
    const { data } = response;

    return data;
  },
);

export const fetchAsyncCarleasing = createAsyncThunk(
  "applicatants/carleasing",
  async () => {
    const response = await axios.get(`${carleasingApiUrl}/carleasing`);
    const { data } = response;
    console.log("Car Leasing Data:", data);
    return data;
  },
);

// get Provinces
export const fetchAsyncProvinces = createAsyncThunk(
  "location/provinces",
  async () => {
    const response = await axios.get(`${apiUrl}/provinces`);
    const { data } = response;
    return data;
  },
);

// get Districts
export const fetchAsyncDistricts = createAsyncThunk(
  "location/districts",
  async ({ province }) => {
    const response = await axios.get(
      `${apiUrl}/provinces/${province}/districts`,
    );
    const { data } = response;
    return data.districts;
  },
);

// Fetch Sectors
export const fetchAsyncSectors = createAsyncThunk(
  "location/sectors",
  async ({ district }) => {
    const response = await axios.get(`${apiUrl}/districts/${district}/sectors`);
    const { data } = response;

    return data.sectors;
  },
);

// Fetch Cells
export const fetchAsyncCells = createAsyncThunk(
  "location/cells",
  async ({ sector }) => {
    const response = await axios.get(`${apiUrl}/sectors/${sector}/cells`);
    const { data } = response;

    return data.cells;
  },
);

// Fetch Villages
export const fetchAsyncVillages = createAsyncThunk(
  "location/villages",
  async ({ cell }) => {
    const response = await axios.get(`${apiUrl}/cells/${cell}/villages`);
    const { data } = response;
    return data.villages;
  },
);

// Fetch agents
export const fetchAsynAgents = createAsyncThunk(
  "registered/agent",
  async () => {
    const response = await axios.get(
      `https://applicationbackend.jalikoi.rw/api/v1/agent`,
    );
    const { data } = response;
    return data;
  },
);

// Fetch identification
export const fetchAsynUserIdentification = createAsyncThunk(
  "registered/identification",
  async ({ contact }) => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${identificationToken}`,
    };

    const response = await axios.get(
      `https://payment.jalikoi.rw/api/v1/accountholder/identification?msisdn=25${contact}`,
      { headers },
    );
    const { data } = response;
    return data;
  },
);
export const fetchAsynUserinformation = createAsyncThunk(
  "registered/information",
  async ({ contact }) => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${identificationToken}`,
    };

    const response = await axios.get(
      `https://payment.jalikoi.rw/api/v1/accountholder/information?msisdn=25${contact}`,
      { headers },
    );
    const { data } = response;
    return data;
  },
);
// Fetch agent Applications
export const fetchAsynagentApplications = createAsyncThunk(
  "applications/agent",
  async ({ loggedInAgent, searchQuery, selectedRange, currentPage }) => {
    const response = await axios.get(
      `https://applicationbackend.jalikoi.rw/api/v1/application/agent/${loggedInAgent.id}?page=${currentPage}&date_from=${selectedRange[0]}&date_to=${selectedRange[1]}&searchQuery=${searchQuery}`,
    );
    const { data } = response;
    return data;
  },
);
// Fetch Application Step Data

export const fetchAsynApplicationStepData = createAsyncThunk(
  "application/step/data",
  async ({ phone, step }) => {
    try {
      // Sending data using POST request
      const response = await axios.post(`${prodApiUrl}/application/step-data`, {
        phone,
        step,
      });

      const { data } = response;

      return data;
    } catch (error) {
      console.error("Error in fetching step data:", error);
      throw new Error(error.message);
    }
  },
);

// CAR application

export const fetchAsyncCarLeasingStepData = createAsyncThunk(
  "carleasing/application/step/data",
  async ({ phone, step }) => {
    try {
      // Sending data using POST request
      const response = await axios.post(`${prodApiUrl}/carleasing/step-data`, {
        phone,
        step,
      });

      const { data } = response;

      console.log("Car Leasing Step Data:", data);

      return data;
    } catch (error) {
      console.error("Error in fetching step data:", error);
      throw new Error(error.message);
    }
  },
);

const initialState = {
  // carleasing step data
  carLeasingStepData: null,
  isLoadingCarLeasingStepData: false,

  // car leasing
  carLeasingData: null,
  isLoadingCarLeasing: false,

  // Store rider's phone number
  phoneNumber: "",

  riderList: {},
  userIdentification: null,
  userinformation: null,

  currentStepData: {},
  isStepdata: false,

  agentsList: null,
  agentApplicationsList: null,
  isLoadingAgents: false,
  motoleasingList: null,
  isLoadingmotoleasing: false,

  user: savedUser ? JSON.parse(savedUser) : null,
  agent: agentInfo ? JSON.parse(agentInfo) : null,

  loggedinuserInfo: null,

  applicatantsApplications: null,
  isLoadingApplications: false,
  // locations
  provinces: [],
  districts: [],
  sectors: [],
  cells: [],
  villages: [],
  isLoadingProvinces: false,
  isLoadingDistricts: false,
  isLoadingSectors: false,
  isLoadingCells: false,
  isLoadingVillages: false,
};

const untappedSlice = createSlice({
  name: "untapped",
  initialState,
  reducers: {
    addRiders: (state, action) => {
      state.riderList = action.payload;
    },
    setRiderPhoneNumber: (state, action) => {
      state.phoneNumber = action.payload;
    },
  },

  extraReducers: {
     // carleasing step data
     [fetchAsyncCarLeasingStepData.pending]: (state) => {
       state.isLoadingCarLeasingStepData = true;
     },
     [fetchAsyncCarLeasingStepData.fulfilled]: (state, { payload }) => {
       return {
         ...state,
         isLoadingCarLeasingStepData: false,
         carLeasingStepData: payload.data,
       };
     },
     [fetchAsyncCarLeasingStepData.rejected]: (state) => {
       state.isLoadingCarLeasingStepData = false;
     },
    // current Step Data
    [fetchAsynApplicationStepData.pending]: (state) => {
      state.isStepdata = true;
    },
    [fetchAsynApplicationStepData.fulfilled]: (state, { payload }) => {
      return { ...state, isStepdata: false, currentStepData: payload.data };
    },

    [fetchAsynApplicationStepData.rejected]: (state) => {
      state.isStepdata = false;
    },

    // userIdentification
    [fetchAsynUserIdentification.pending]: (state) => {
      state.isLoadingAgentsApplication = true;
    },
    [fetchAsynUserIdentification.fulfilled]: (state, { payload }) => {
      return {
        ...state,
        isLoadingAgentsApplication: false,
        userIdentification: payload.data,
      };
    },
    [fetchAsynUserIdentification.rejected]: (state) => {
      state.isLoadingAgentsApplication = false;
    },

    [fetchAsynUserinformation.pending]: (state) => {
      state.isLoadingAgentsApplication = true;
    },
    [fetchAsynUserinformation.fulfilled]: (state, { payload }) => {
      return {
        ...state,
        isLoadingAgentsApplication: false,
        userinformation: payload.data,
      };
    },
    [fetchAsynUserinformation.rejected]: (state) => {
      state.isLoadingAgentsApplication = false;
    },
    //agent Applications
    [fetchAsynagentApplications.pending]: (state) => {
      state.isLoadingAgentsApplication = true;
    },
    [fetchAsynagentApplications.fulfilled]: (state, { payload }) => {
      return {
        ...state,
        isLoadingAgentsApplication: false,
        agentApplicationsList: payload,
      };
    },
    [fetchAsynagentApplications.rejected]: (state) => {
      state.isLoadingAgentsApplication = false;
    },
    // agents
    [fetchAsynAgents.pending]: (state) => {
      state.isLoadingAgents = true;
    },
    [fetchAsynAgents.fulfilled]: (state, { payload }) => {
      return { ...state, isLoadingAgents: false, agentsList: payload };
    },
    [fetchAsynAgents.rejected]: (state) => {
      state.isLoadingAgents = false;
    },
    //  // car leasing
    [fetchAsyncCarleasing.pending]: (state) => {
      state.isLoadingCarLeasing = true;
    },
    [fetchAsyncCarleasing.fulfilled]: (state, { payload }) => {
      return {
        ...state,
        isLoadingCarLeasing: false,
        carLeasingData: payload.data,
      };
    },
    [fetchAsyncCarleasing.rejected]: (state) => {
      state.isLoadingCarLeasing = false;
    },

    // motor leasinhg
    [fetchAsyncMotoleasing.pending]: (state) => {
      state.isLoadingmotoleasing = true;
    },
    [fetchAsyncMotoleasing.fulfilled]: (state, { payload }) => {
      return {
        ...state,
        isLoadingmotoleasing: false,
        motoleasingList: payload,
      };
    },
    [fetchAsyncMotoleasing.rejected]: (state) => {
      state.isLoadingmotoleasing = false;
    },

    [fetchAsyncLoggedinUser.pending]: (state) => {
      state.isLoading = true;
    },
    [fetchAsyncLoggedinUser.fulfilled]: (state, { payload }) => {
      return { ...state, isLoading: false, loggedinuserInfo: payload };
    },
    [fetchAsyncLoggedinUser.rejected]: (state) => {
      state.isLoading = false;
    },

    // Provinces
    [fetchAsyncProvinces.pending]: (state) => {
      state.isLoadingProvinces = true;
    },
    [fetchAsyncProvinces.fulfilled]: (state, { payload }) => {
      state.isLoadingProvinces = false;
      state.provinces = payload;
    },
    [fetchAsyncProvinces.rejected]: (state) => {
      state.isLoadingProvinces = false;
    },

    // Districts
    [fetchAsyncDistricts.pending]: (state) => {
      state.isLoadingDistricts = true;
    },
    [fetchAsyncDistricts.fulfilled]: (state, { payload }) => {
      state.isLoadingDistricts = false;
      state.districts = payload;
    },
    [fetchAsyncDistricts.rejected]: (state) => {
      state.isLoadingDistricts = false;
    },

    // Sectors
    [fetchAsyncSectors.pending]: (state) => {
      state.isLoadingSectors = true;
    },
    [fetchAsyncSectors.fulfilled]: (state, { payload }) => {
      state.isLoadingSectors = false;
      state.sectors = payload;
    },
    [fetchAsyncSectors.rejected]: (state) => {
      state.isLoadingSectors = false;
    },

    // Cells
    [fetchAsyncCells.pending]: (state) => {
      state.isLoadingCells = true;
    },
    [fetchAsyncCells.fulfilled]: (state, { payload }) => {
      state.isLoadingCells = false;
      state.cells = payload;
    },
    [fetchAsyncCells.rejected]: (state) => {
      state.isLoadingCells = false;
    },

    // Villages
    [fetchAsyncVillages.pending]: (state) => {
      state.isLoadingVillages = true;
    },
    [fetchAsyncVillages.fulfilled]: (state, { payload }) => {
      state.isLoadingVillages = false;
      state.villages = payload;
    },
    [fetchAsyncVillages.rejected]: (state) => {
      state.isLoadingVillages = false;
    },
  },
});

export const { addRiders } = untappedSlice.actions;
export const { setRiderPhoneNumber } = untappedSlice.actions;

export const loadingAlldata = (state) => state.untapped.isLoadingApplications;
// car leasing
export const getAllCarleasingList = (state) => state.untapped.carLeasingData;
export const isLoadingCarleasing = (state) =>
  state.untapped.isLoadingCarleasing;

// motoleassing
export const getAllMotoleasingList = (state) => state.untapped.motoleasingList;
export const isLoadingmotoleasing = (state) =>
  state.untapped.isLoadingmotoleasing;

// locations
export const getAllProvinces = (state) => state.untapped.provinces;
export const getAllDistricts = (state) => state.untapped.districts;
export const getAllSectors = (state) => state.untapped.sectors;
export const getAllCells = (state) => state.untapped.cells;
export const getAllVillages = (state) => state.untapped.villages;
export const isLoadingProvinces = (state) => state.untapped.isLoadingProvinces;
export const isLoadingDistricts = (state) => state.untapped.isLoadingDistricts;
export const isLoadingSectors = (state) => state.untapped.isLoadingSectors;
export const isLoadingCells = (state) => state.untapped.isLoadingCells;
export const isLoadingVillages = (state) => state.untapped.isLoadingVillages;
// agent information
export const getAgent = (state) => state.untapped.agent;
export const getAllAgent = (state) => state.untapped.agentsList;
export const isLoadingAgents = (state) => state.untapped.isLoadingAgents;

export const getAllAgentApplications = (state) =>
  state.untapped.agentApplicationsList;
export const isLoadingAgentsApplication = (state) =>
  state.untapped.isLoadingAgentsApplication;
// user information
export const getUserIdentification = (state) =>
  state.untapped.userIdentification;
export const getUserInformation = (state) => state.untapped.userinformation;

// Current Step Data
export const getCurrentStepData = (state) => state.untapped.currentStepData;
export const isCurrentStepData = (state) => state.untapped.isCurrentStepData;

//  // carleasing step data
export const getCarLeasingStepData = (state) => state.untapped.carLeasingStepData;
export const isLoadingCarLeasingStepData = (state) => state.untapped.isLoadingCarLeasingStepData;

export const getUser = (state) => state.untapped.user;
export const getloggedinUser = (state) => state.untapped.loggedinuserInfo;
export default untappedSlice.reducer;
